// store/menuSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isChatOpen: false,
  //translate: '-100vw,0,0',
};

const chatSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    openChat: (state) => {
      state.isChatOpen = true;
     // state.translate = '0,0,0';
    },
    closeChat: (state) => {
      state.isChatOpen = false;
     // state.translate = '-100vw,0,0';
    },
    toggleChat: (state) => {
      state.isChatOpen = !state.isChatOpen;
     // state.translate = state.isOpen ? '0,0,0' : '-100vw,0,0';
    },
  },
});

export const { openChat, closeChat, toggleChat } = chatSlice.actions;
export default chatSlice.reducer;
